module.exports = __webpack_public_path__ + "assets/img/doc_home.c83cb8b7.png";